import { Component } from 'react';

// Component to set window.docdone when componentWillUnmount.
// window.docdone is for Snaphots to detect when an app has rendered.
// For example, include in a conditional that shows while app loading, then when loading is done it will unmount.
// 100ms timeout if there for a bit of extra time to allow for animations, images etc to finish loading.

interface Props {
    timeout?: number;
}

class DocDone extends Component<Props> {
    componentWillUnmount() {
        const { timeout = 100 } = this.props;
        setTimeout(() => {
            (window as any).docdone = true;
        }, timeout);
    }

    render() {
        return null;
    }
}

export default DocDone;


// WEBPACK FOOTER //
// ./src/Components/DocDone.tsx